import React, { useRef, useState } from 'react'

import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  Toolbar,
} from '@material-ui/core'
import { AccountCircleOutlined } from '@material-ui/icons'

import useAuthGuest from 'hooks/useAuthGuest'
import useCustomTheme from 'hooks/useCustomTheme'
import * as service from 'service'
import logoDponetWhite from 'images/dponet-logo-white.svg'
import UserSettingsDialog from 'views/Guests/components/UserSettingsDialog'
import useStyles from './styles'

const TopBar = () => {
  const classes = useStyles()
  const { company, loadOut, organizationSlug, portalToken } = useAuthGuest()
  const { customLogo } = useCustomTheme()
  const anchorRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)

  const handleOpenSettings = () => {
    setMenuOpen(false)
    setSettingsOpen(true)
  }

  const handleLogout = () => {
    setMenuOpen(false)
    service.guestPortal.auth.logout(portalToken, organizationSlug)
    loadOut()
  }

  return (
    <AppBar elevation={0} className={classes.root}>
      <Toolbar>
        {customLogo && (
          <img
            src={customLogo}
            alt={company?.name || 'Logo'}
            className={classes.logo}
          />
        )}
        <Box flexGrow={1} />
        <IconButton
          ref={anchorRef}
          className={classes.userButton}
          onClick={() => setMenuOpen(true)}
        >
          <AccountCircleOutlined fontSize="large" />
        </IconButton>
        <Menu
          anchorEl={anchorRef.current}
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Button color="secondary" fullWidth onClick={handleOpenSettings}>
            Configurações
          </Button>
          <Button color="secondary" fullWidth onClick={handleLogout}>
            Sair
          </Button>
        </Menu>
        <UserSettingsDialog open={settingsOpen} setOpen={setSettingsOpen} />
      </Toolbar>
    </AppBar>
  )
}

export default TopBar
